<rad-popover 
  position="top"
  offset="50"
  class="help-popover"
  popover-append-to="body"
  (click)="$event.stopPropagation()">
  <rad-icon 
    name="info" 
    size="sm"
    style="--rad-icon-color-fill-light: #4E60EE;">
    </rad-icon>
    <rad-popover-custom-content>
        <div
            class="tooltip-container" 
            style="
            font-size: 16px; 
            font-weight: 400; 
            line-height: 140%; 
            color: #464247; 

            margin-top: 0px;
            margin-bottom: 0px;
            "
            [innerHTML]="helpText | markdown"
         ></div>
    </rad-popover-custom-content>
</rad-popover>
